import axios from 'axios';

import { CONFIG } from 'src/config-global';

import { handleApiError, extractResponseData } from './errorHandler';

// ----------------------------------------------------------------------


const axiosInstance = axios.create({ baseURL: CONFIG.site.serverUrl });

axiosInstance.interceptors.response.use(
  (response) => {
    // Transform response data to handle new API format
    if (response.data) {
      response.data = extractResponseData(response.data);
    }
    return response;
  },
  (error) => {
    // Handle API errors with new error handler - now with toast enabled
    const handledError = handleApiError(error, { showToast: true, logError: true });
    return Promise.reject(handledError.originalError || error);
  }
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.get(url, { ...config });

    // Response is already transformed by interceptor
    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

// ----------------------------------------------------------------------

export const createAuthenticatedAxiosInstance = (token) => {
  const instance = axios.create({ baseURL: CONFIG.site.serverUrl });

  instance.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      // Transform response data to handle new API format
      if (response.data) {
        response.data = extractResponseData(response.data);
      }
      return response;
    },
    (error) => {
      // Handle API errors with new error handler - now with toast enabled
      const handledError = handleApiError(error, { showToast: true, logError: true });
      return Promise.reject(handledError.originalError || error);
    }
  );

  return instance;
};


// ----------------------------------------------------------------------
export const authorizedFetcher = async (url, token) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axiosInstance.get(url, config);
    // Response is already transformed by interceptor
    return response.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};
